import API_URL from 'config.js';
import axios, { AxiosInstance } from 'axios';
import { AxiosRequestManager } from 'utils/AxiosRequestManager';
const base64 = require('base-64');
const utf8 = require('utf8');

const ax: AxiosInstance = axios.create({
    baseURL: API_URL,
});

const axs: AxiosInstance = axios.create({
    baseURL: 'https://clinicaltables.nlm.nih.gov/api/rxterms/v3/search?terms',
});

// Add a request interceptor
ax.interceptors.request.use(
    (config: any) => {
        const controller = new AbortController();
        config.signal = controller.signal;

        const key = `${config.method}:${config.url}`;
        const existingController = AxiosRequestManager.getController(key);
        if (existingController) {
            existingController.abort();
        }

        const user = sessionStorage.getItem('username') || localStorage.getItem('username');
        const pass = sessionStorage.getItem('password') || localStorage.getItem('password');

        let token = null;
        if (user && pass && user !== 'null' && pass !== 'null') {
            const text = user + ':' + pass;
            const bytes = utf8.encode(text);
            token = base64.encode(bytes);
        }

        const formDataEndpoints = [
            'md_management/add_templatemedication',
            'account/saveAccount',
            'patient/requestmedication',
            'docrepo/consentdocupload',
            'docrepo/resultupload',
            'docrepo/docupload',
            'service_request/accountsaveServicerequest',
            'service_request/adminsaveServicerequest',
            'account/saveAccount_public',
            'account/saveAccount_agreement',
            'account/userinfocall',
            'service_request/add_templ_cover_data',
            'service_request/save_tickets',
            'docrepo/resourceupload',
            'docrepo/resourceupdate',
            'service_request/saveticket_conversation',
            
        ];

        const isResourceDetailPublic = 
            (config.url.endsWith('docrepo/resourcedetail') || 
             config.url.endsWith('docrepo/resourcedetail/') || 
             config.url.includes('docrepo/resourcedetail?')) &&
            !config.url.includes('docrepo/resourcedetail_info');

        const isPublicEndpoint = 
            config.url.includes('auth/login') ||
            config.url.includes('auth/password_reset') ||
            config.url.includes('auth/reset-password/verify-token') ||
            config.url.includes('auth/password_reset/confirm/') ||
            config.url.includes('account/getpublicaccount') ||
            config.url.includes('patient/addpublicpatient') ||
            config.url.includes('patient/publicrequest_intakeform') ||
            config.url.includes('md_management/publicphq_mdata') ||
            config.url.includes('account/getcountrystates') ||
            config.url.includes('account/saveAccount_public') ||
            config.url.includes('account/userinfocall') ||
            config.url.includes('account/saveAccount_agreement') ||
            config.url.includes('service_request/consent_link_verify') ||
            config.url.includes('docrepo/consentdocupload_link') ||
            isResourceDetailPublic; 

        if (!formDataEndpoints.some((endpoint: any) => config.url.includes(endpoint))) {
            if (!isPublicEndpoint) {
                if (token) {
                    config.headers['Authorization'] = 'Basic ' + token;
                }
                config.headers['Content-Type'] = 'application/json';
                config.headers['Accept'] = 'application/json';
            } else {
                if (
                    config.url.includes('patient/publicrequest_intakeform') ||
                    config.url.includes('account/saveAccount_public') ||
                    config.url.includes('account/userinfocall') ||
                    config.url.includes('account/saveAccount_agreement') ||
                    config.url.includes('docrepo/consentdocupload_link')
                ) {
                    config.headers['Content-Type'] = 'multipart/form-data';
                } else {
                    config.headers['Content-Type'] = 'application/json';
                }
                config.headers['Accept'] = 'application/json';
            }
        } else {
            if (token && !isPublicEndpoint) {
                config.headers['Authorization'] = 'Basic ' + token;
            }
            if (config.data instanceof FormData) {
                config.headers['Content-Type'] = 'multipart/form-data';
            } else {
                config.headers['Content-Type'] = 'application/json';
            }
            config.headers['Accept'] = 'application/json';
        }

        AxiosRequestManager.addController(key, controller);
        return config;
    },
    (error: any) => {
        Promise.reject(error);
    },
);

axs.interceptors.request.use(
    (config: any) => {
        config.headers['Content-Type'] = 'application/json';
        config.headers['Accept'] = 'application/json';
        return config;
    },
    (error: any) => {
        Promise.reject(error);
    },
);

ax.interceptors.response.use(
    (response) => {
        const key = `${response.config.method}:${response.config.url}`;
        AxiosRequestManager.removeController(key);
        return response;
    },
    (error) => {
        const key = `${error.config?.method}:${error.config?.url}`;
        AxiosRequestManager.removeController(key);
        return Promise.reject(error);
    }
);

export { axs, ax };